import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all users with pagination and optional search */
export const getUsers = async (page = 1, limit = 10, filters = {}) => {
    try {
        const filterObj = typeof filters === 'string' ? { search: filters } : (filters || {});
        const params = { page };
        if (limit !== undefined && limit !== 10) {
            params.limit = limit;
        }
        if (filterObj.search) params.search = filterObj.search;
        if (filterObj.role) params.role = filterObj.role;
        if (filterObj.isEmailVerified !== undefined && filterObj.isEmailVerified !== '') {
            params.isEmailVerified = filterObj.isEmailVerified;
        }
        if (filterObj.provider) params.provider = filterObj.provider;
        if (filterObj.sort) params.sort = filterObj.sort;
        if (filterObj.joined) params.joined = filterObj.joined;
        if (filterObj.startDate) params.startDate = filterObj.startDate;
        if (filterObj.endDate) params.endDate = filterObj.endDate;
        if (filterObj.status) params.status = filterObj.status;

        const response = await axios.get(`${apiUrlOne}/users`, {
            params,
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

/* Fetch payment accounts for a specific user */
export const getPaymentAccounts = async (userId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/payment-accounts/admin/${userId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching payment accounts:", error);
        throw error;
    }
};

/* Fetch retreats for a specific user */
export const getUserRetreats = async (userId, page = 1, limit = 10) => {
    try {
        const response = await axios.get(`${apiUrlOne}/retreat-listings/user/${userId}?page=${page}&limit=${limit}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user retreats:", error);
        throw error;
    }
};

/* Fetch bookings for a specific user */
export const getUserBookings = async (userId, page = 1, limit = 10) => {
    try {
        const response = await axios.get(`${apiUrlOne}/bookings/admin/user/${userId}?page=${page}&limit=${limit}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user bookings:", error);
        throw error;
    }
};

/* Fetch single user by ID */
export const getUserById = async (userId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/users/admin/${userId}`, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user details:", error);
        throw error;
    }
};

/* Update user details by ID */
export const updateUser = async (userId, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/users/${userId}`, data, {
            headers: {
                'accept': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error);
        throw error;
    }
};

/* Update user status by ID (admin: active / suspended) */
export const updateUserStatus = async (userId, status) => {
    try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.put(
            `${apiUrlOne}/users/admin/${userId}/status`,
            { status },
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...(token && { 'Authorization': `Bearer ${token}` })
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating user status:", error);
        throw error;
    }
};
